/**
 * @name crud_marketing_leads.js
 * @author Fellipe Orsini
 * @package clinic-mvp\app\assets\js\crud_marketing_insights.js
 */

// Importações de bibliotecas externas necessárias para o funcionamento do módulo
const moment = require("moment-timezone"); // Para manipulação de datas e fusos horários
const XLSX = require("xlsx"); // Para manipulação de arquivos Excel
import TableBuilder from "./table_builder.js"; // Classe para construção de tabelas

// Declaração de variáveis globais que serão preenchidas posteriormente
var getBaseDir = null,
  apiCall = null,
  userHasRole = null,
  moeda2float = null,
  betterMoeda2float = null,
  currencyToFloat = null,
  float2moeda = null,
  mountSortList = null,
  userHasRole = null;

// jQuery document.ready - Executa quando o DOM estiver completamente carregado
$(function () {
  // Importação dinâmica do módulo utils.js
  import("./utils.js").then((utils) => {
    // Atribuição das funções utilitárias às variáveis globais
    getBaseDir = utils.getBaseDir; // Função para obter o diretório base
    apiCall = utils.apiCall; // Função para fazer chamadas à API
    userHasRole = utils.userHasRole; // Função para verificar permissões do usuário
    moeda2float = utils.moeda2float; // Função converter valor monetário em flutuante
    betterMoeda2float = utils.betterMoeda2float; // Função converter valor monetário em flutuante
    currencyToFloat = utils.currencyToFloat; // Função converter valor monetário em flutuante
    float2moeda = utils.float2moeda; // Função converter valor monetário em flutuante
    mountSortList = utils.mountSortList;
    userHasRole = utils.userHasRole;

    // Verifica se o usuário está logado, se não estiver, interrompe a execução
    if (!utils.isUserLoggedIn()) return;

    // Verifica se estamos na página correta (/marketing/insights)
    // Se não estiver, interrompe a execução
    if (location.pathname !== utils.getBaseDir() + "marketing/insights") return;

    // Inicializa a classe principal passando as dependências necessárias
    new MarketingInsights(true, {
      getBaseDir: utils.getBaseDir,
      apiCall: utils.apiCall,
      userHasRole: utils.userHasRole,
      moeda2float: utils.moeda2float,
      betterMoeda2float: utils.betterMoeda2float,
      currencyToFloat: utils.currencyToFloat,
      userHasRole: utils.userHasRole,
    });
  });
});

// Classe principal que gerencia os insights de marketing
class MarketingInsights {
  // Constructor recebe dois parâmetros:
  // onloadList: booleano para indicar se deve carregar a lista ao inicializar
  // deps: objeto com as dependências necessárias (funções utilitárias)
  constructor(onloadList = false, deps = {}) {
    this.deps = deps;
    this.onlyFranchise = false;
    // Precisamos dessa váriavel para manter salvo em memória
    // as informações que irão na tabela
    this.dadosTabela = {
      // =========================================== META ===========================================
      // dados de campanhas
      CAMPANHAS_CLINICA: [],
      CAMPANHAS_ROBO: [],
      // métricas de insights
      INSIGHTS_CLINICA: [],
      INSIGHTS_ROBO: [],
      // totalizadores
      TOTAIS_CLINICA: {
        custo: 0,
        leads: 0,
        pn: 0,
        aproveitamento: 0,
        custo_lead: 0,
        custo_pn: 0,
      },
      TOTAIS_ROBO: {
        custo: 0,
        leads: 0,
        pn: 0,
        aproveitamento: 0,
        custo_lead: 0,
        custo_pn: 0,
      },
      TOTAIS_INSIGHTS_CLINICA: {
        pn_geral: 0,
        pn_lead: 0,
        pit_geral: 0,
        pit_lead: 0,
        aproveitamento: 0,
        custo_pit: 0,
        custo_pit_geral: 0,
        pim: 0,
        fat_pim: 0,
        fat_pit: 0,
        tm_pn: 0,
        tm_pn: 0,
        aproveitamento2: 0,
      },
      TOTAIS_INSIGHTS_ROBO: {
        pn_geral: 0,
        pn_lead: 0,
        pit_geral: 0,
        pit_lead: 0,
        aproveitamento: 0,
        custo_pit: 0,
        custo_pit_geral: 0,
        pim: 0,
        fat_pim: 0,
        fat_pit: 0,
        tm_pn: 0,
        tm_pn: 0,
        aproveitamento2: 0,
      },

      // =========================================== GOOGLE ===========================================
      // dados de campanhas
      GOOGLE_ADS: [],
      GOOGLE_ORGANICO: [],
      GOOGLE_SOMA_LIGACOES: [],
      // métricas de insights
      INSIGHTS_GOOGLE_ADS: [],
      // totalizadores
      TOTAL_GOOGLE_ADS: {
        impressoes: 0,
        cliques: 0,
        cpc: 0,
        custo: 0,
        imp_chamadas: 0,
        ligacoes: 0,
      },
      TOTAL_GOOGLE_ORGANICO: {
        visualizaram_google: 0,
        interacoes_perfil: 0,
        ligacoes: 0,
        solicitacoes_rota: 0,
        cliques_site: 0
      },
      TOTAL_GOOGLE_SOMA_LIGACOES: {
        total: 0
      },
      TOTAIS_INSIGHTS_GOOGLE: {
        pn_geral: 0,
        pn_lead: 0,
        pit_geral: 0,
        pit_lead: 0,
        aproveitamento: 0,
        custo_pit: 0,
        custo_pit_geral: 0,
        pim: 0,
        fat_pim: 0,
        fat_pit: 0,
        tm_pn: 0,
        tm_pn: 0,
        aproveitamento2: 0,
      },

      // =========================================== BANNER ===========================================
      // dados de campanhas
      CAMPANHAS_BANNER: [],
      // métricas de insights
      INSIGHTS_BANNER: [],
      // totalizadores
      TOTAIS_BANNER: {
        custo: 0,
        leads: 0,
        pn: 0,
        aproveitamento: 0,
        custo_lead: 0,
        custo_pn: 0,
      },
      TOTAIS_INSIGHTS_BANNER: {
        pn_geral: 0,
        pn_banner: 0,
        pit_geral: 0,
        pit_banner: 0,
        aproveitamento: 0,
        custo_pit: 0,
        custo_pit_geral: 0,
        pim: 0,
        fat_pim: 0,
        fat_pit: 0,
        tm_pn: 0,
        tm_pn: 0,
        aproveitamento2: 0,
      },

      // =========================================== INFLUENCERS ===========================================
      // dados de campanhas
      CAMPANHAS_INFLUENCERS: [],
      // métricas de insights
      INSIGHTS_INFLUENCERS: [],
      // totalizadores
      TOTAIS_INFLUENCERS: {
        custo: 0,
        leads: 0,
        pn: 0,
        aproveitamento: 0,
        custo_lead: 0,
        custo_pn: 0,
      },
      TOTAIS_INSIGHTS_INFLUENCERS: {
        pn_geral: 0,
        pn_influencer: 0,
        pit_geral: 0,
        pit_influencer: 0,
        aproveitamento: 0,
        custo_pit: 0,
        custo_pit_geral: 0,
        pim: 0,
        fat_pim: 0,
        fat_pit: 0,
        tm_pn: 0,
        tm_pn: 0,
        aproveitamento2: 0,
      },

      // =================================================== DISPAROS ===================================================
      DISPAROS: {
        investimento_total: 0,
        total_contratos: 0,
        total_avaliacoes: 0,
        retorno_em_contratos: 0,
        retorno_em_avaliacoes: 0,
        retorno_total: 0,
      },

      // =================================================== CHATWOOT ===================================================
      CHATWOOT: [],
      TOTAL_CHATWOOT: {
        custo: 0,
      },
    };
    this.somaMesAtual = false;
    this.tipoRelatorio = 'meta';
    this.dataFiltro = moment().format('YYYY-MM-DD');
    this.dataFiltroFim = moment().format('YYYY-MM-DD');
    $('#filtrarData').val(this.dataFiltro);
    $('#filtrarDataFim').val(this.dataFiltroFim);
    this.carregarFiliais();
    this.detectarAlteracoes();
  }

  // =================== Carrega dados das filiais usando um intervalo
  /**
   * Método responsável por carregar os dados das filiais do sistema
   * Este método usa um intervalo (setInterval) para verificar periodicamente
   * se os dados das filiais já estão disponíveis no objeto window._sessionData
   */
  carregarFiliais() {
    // Armazena referência da classe atual para uso dentro do setInterval
    let self = this;

    // Cria um intervalo que verifica a cada 900ms (aproximadamente 1 segundo)
    // se os dados das filiais já foram carregados
    var intv = setInterval(function () {
      // Verifica se o objeto businessBranches (filiais) já existe nos dados da sessão
      if (window._sessionData.businessBranches) {
        // Quando encontrar os dados, armazena em uma constante
        const filiais = window._sessionData.businessBranches;

        // Chama o método que vai processar os dados das filiais
        self.montarDadosTabela(filiais);

        // Limpa o intervalo para parar de verificar, já que os dados foram encontrados
        clearInterval(intv);
      }
    }, 900); // Tempo em milissegundos entre cada verificação
  }

  // =================== Processa os dados das filiais
  /**
   * Método responsável por inicializar as estruturas de dados para cada filial
   * Prepara os arrays que armazenarão dados de campanhas e insights, tanto para clínica quanto para robô
   * @param {Object} filiais - Objeto contendo os dados das filiais do sistema
   */
  montarDadosTabela(filiais) {
    // Log para debug mostrando os dados recebidos e quantidade de filiais
    console.log("montarDadosTabela", filiais, filiais.length);

    // Converte o objeto de filiais em um array para facilitar a iteração
    let valoresFiliais = Object.values(filiais);

    // Variável que será usada para construir o HTML (não utilizada no momento)
    let htmlCampanhas = "";

    // Itera sobre cada filial para inicializar suas estruturas de dados
    for (let index = 0; index < valoresFiliais.length; index++) {
      const filial = valoresFiliais[index];

      // Verifica se a filial possui um ID válido (código comentado para debug)
      if ("ID" in filial) {
        // Verificação de ID válido
      } else {
        // Log caso não encontre ID
      }

      // Inicializa dados de campanhas para a clínica
      // Cada filial terá seus próprios indicadores zerados
      this.dadosTabela.CAMPANHAS_CLINICA.push({
        id: filial.ID,
        nome: filial.FILIAL,
        custo: 0, // Custo total da campanha
        leads: 0, // Quantidade de leads gerados
        pn: 0, // Quantidade de Prontuários Novos
        aproveitamento: 0, // Taxa de aproveitamento (%)
        custo_lead: 0, // Custo por lead
        custo_pn: 0, // Custo por Prontuário Novo
      });

      // Inicializa dados de campanhas para o robô
      // Estrutura similar à da clínica, mas para ações automatizadas
      this.dadosTabela.CAMPANHAS_ROBO.push({
        id: filial.ID,
        nome: filial.FILIAL,
        custo: 0, // Custo total da campanha
        leads: 0, // Quantidade de leads gerados
        pn: 0, // Quantidade de Prontuários Novos
        aproveitamento: 0, // Taxa de aproveitamento (%)
        custo_lead: 0, // Custo por lead
        custo_pn: 0, // Custo por Prontuário Novo
      });

      // Inicializa métricas de insights para a clínica
      // Dados mais detalhados sobre performance e resultados
      this.dadosTabela.INSIGHTS_CLINICA.push({
        id: filial.ID,
        nome: filial.FILIAL,
        pn_geral: 0, // Prontuários Novos geral
        pn_lead: 0, // Prontuários Novos de leads
        pit_geral: 0, // Pacientes em Tratamento geral
        pit_lead: 0, // Pacientes em Tratamento de leads
        aproveitamento: 0, // Taxa de aproveitamento
        custo_pit: 0, // Custo por Paciente em Tratamento
        custo_pit_geral: 0, // Custo geral por Paciente em Tratamento
        pim: 0, // Pacientes com Implante
        fat_pim: 0, // Faturamento de Pacientes com Implante
        fat_pit: 0, // Faturamento de Pacientes em Tratamento
        tm_pn: 0, // Ticket Médio de Prontuários Novos
        aproveitamento2: 0, // Taxa de aproveitamento secundária
      });

      // Inicializa métricas de insights para o robô
      // Mesma estrutura que INSIGHTS_CLINICA, mas para ações automatizadas
      this.dadosTabela.INSIGHTS_ROBO.push({
        id: filial.ID,
        nome: filial.FILIAL,
        pn_geral: 0, // Prontuários Novos geral
        pn_lead: 0, // Prontuários Novos de leads
        pit_geral: 0, // Pacientes em Tratamento geral
        pit_lead: 0, // Pacientes em Tratamento de leads
        aproveitamento: 0, // Taxa de aproveitamento
        custo_pit: 0, // Custo por Paciente em Tratamento
        custo_pit_geral: 0, // Custo geral por Paciente em Tratamento
        pim: 0, // Pacientes com Implante
        fat_pim: 0, // Faturamento de Pacientes com Implante
        fat_pit: 0, // Faturamento de Pacientes em Tratamento
        tm_pn: 0, // Ticket Médio de Prontuários Novos
        aproveitamento2: 0, // Taxa de aproveitamento secundária
      });

      this.dadosTabela.GOOGLE_ADS.push({
        id: filial.ID,
        nome: filial.FILIAL,
        impressoes: 0,
        cliques: 0,
        cpc: 0,
        custo: 0,
        imp_chamadas: 0,
        ligacoes: 0,
      })

      this.dadosTabela.GOOGLE_ORGANICO.push({
        id: filial.ID,
        nome: filial.FILIAL,
        visualizaram_google: 0,
        interacoes_perfil: 0,
        ligacoes: 0,
        solicitacoes_rota: 0,
        cliques_site: 0
      })

      this.dadosTabela.CAMPANHAS_BANNER.push({
        id: filial.ID,
        nome: filial.FILIAL,
        custo: 0,
        leads: 0,
        pn: 0,
        aproveitamento: 0,
      })

      this.dadosTabela.INSIGHTS_BANNER.push({
        id: filial.ID,
        nome: filial.FILIAL,
        pn_geral: 0,
        pn_banner: 0,
        pit_geral: 0,
        pit_banner: 0,
        aproveitamento: 0,
      })

      this.dadosTabela.CAMPANHAS_INFLUENCERS.push({
        id: filial.ID,
        nome: filial.FILIAL,
        custo: 0,
        leads: 0,
        pn: 0,
        aproveitamento: 0,
      })

      this.dadosTabela.INSIGHTS_INFLUENCERS.push({
        id: filial.ID,
        nome: filial.FILIAL,
        pn_geral: 0,
        pn_influencer: 0,
        pit_geral: 0,
        pit_influencer: 0,
        aproveitamento: 0,
      })
      this.dadosTabela.CHATWOOT.push({
        id: filial.ID,
        nome: filial.FILIAL,
        custo: 0,
      });
    }

    // Após inicializar todas as estruturas, monta as tabelas na interface
    this.montarTabela("campanha"); // Monta tabela de campanhas
    this.montarTabela("insights"); // Monta tabela de insights
    this.montarTabela("google"); // Monta tabela de google
    this.montarTabela("banner"); // Monta tabela de banner
    this.montarTabela("banner_insights"); // Monta tabela de insights banner
    this.montarTabela("influencer"); // Monta tabela de influencer
    this.montarTabela("influencer_insights"); // Monta tabela de insights influencer
    this.montarTabela("disparos"); // Monta tabela de disparos
    this.montarTabela("chatwoot"); // Monta tabela de chatwoot

    //Puxar os dados para a tabela
    this.buscarDados();

    // Log para debug mostrando a estrutura completa inicializada
    console.log("dadosTabela", this.dadosTabela);
  }

  // =================== Monta o HTML das tabelas
  /**
   * Método responsável por construir e exibir as tabelas de campanhas e insights
   * @param {string} tipo_tabela - Tipo de tabela a ser montada ('campanha' ou 'insights')
   */
  montarTabela(tipo_tabela) {
    // Qual tipo de tabela é? Campanhas ou Insights
    switch (tipo_tabela) {
      // =================================================== MONTA TABELA INSIGHTS CAMPANHA ===================================================
      case "campanha": {
        // Inicializa variáveis para armazenar o HTML das tabelas
        let html_clinica = "",
          html_robo = "";

        // Monta as linhas da tabela para cada filial (clínica)
        for (
          let index = 0;
          index < this.dadosTabela.CAMPANHAS_CLINICA.length;
          index++
        ) {
          const dados = this.dadosTabela.CAMPANHAS_CLINICA[index];
          html_clinica += `
            <tr>
              <td >${dados.nome}</td> <!-- Brasília -->
              <td> ${this.deps.userHasRole('MANAGER') ? `${dados.custo}` : `<input type="text" class='form-control js-mkt-insightsCusto mMoney' value= "${dados.custo}" data-tipo="clinica" data-id="${dados.id}">`} </td> <!-- Custo -->
              <td >${this.deps.userHasRole('MANAGER') ? `${dados.leads}` : `<input type="text" class='form-control js-mkt-insightsLeads' value= "${dados.leads}" data-tipo="clinica" data-id="${dados.id}">`}</td><!-- Lead's -->
              <td >${dados.pn}</td><!-- PN -->
              <td >${dados.aproveitamento}</td><!-- % -->
              <td >${dados.custo_lead}</td><!-- Custo Lead -->
              <td >${dados.custo_pn}</td><!-- Custo PN -->
              <td><button class="btn btn-sm btn-primary copy-row-btn" data-branch="${dados.nome}" data-leads="${dados.leads}" data-pn="${dados.pn}" data-aproveitamento="${dados.aproveitamento}">Copiar</button></td>
            </tr> 
          `;
        }

        // Monta as linhas da tabela para cada filial (robô)
        for (
          let index = 0;
          index < this.dadosTabela.CAMPANHAS_ROBO.length;
          index++
        ) {
          const dados = this.dadosTabela.CAMPANHAS_ROBO[index];
          html_robo += `
            <tr>
              <td >${dados.nome}</td> <!-- Brasília -->
              <td> ${this.deps.userHasRole('MANAGER') ? `${dados.custo}` : `<input type="text" class='form-control js-mkt-insightsCusto mMoney' value= "${dados.custo}" data-tipo="robo" data-id="${dados.id}">`} </td> <!-- Custo -->
              <td >${this.deps.userHasRole('MANAGER') ? `${dados.leads}` : `<input type="text" class='form-control js-mkt-insightsLeads' value= "${dados.leads}" data-tipo="robo" data-id="${dados.id}">`}</td><!-- Lead's -->
              <td >${dados.pn}</td><!-- PN -->
              <td >${dados.aproveitamento}</td><!-- % -->
              <td >${dados.custo_lead}</td><!-- Custo Lead -->
              <td >${dados.custo_pn}</td><!-- Custo PN -->
              
            </tr> 
          `;
        }

        // Prepara linha de totais para clínica
        const total_clinica = this.dadosTabela.TOTAIS_CLINICA;
        let html_total_clinica = ` <tr>
              <td >TOTAL:</td> <!-- Brasília -->
              <td >${total_clinica.custo}</td> <!-- Custo -->
              <td >${total_clinica.leads}</td><!-- Lead's -->
              <td >${total_clinica.pn}</td><!-- PN -->
              <td >${total_clinica.aproveitamento}</td><!-- % -->
              <td >${total_clinica.custo_lead}</td><!-- Custo Lead -->
              <td >${total_clinica.custo_pn}</td><!-- Custo PN -->
              
            </tr> `;

        // Prepara linha de totais para robô (similar à clínica)
        const total_robo = this.dadosTabela.TOTAIS_ROBO;
        let html_total_robo = ` <tr>
              <td >TOTAL:</td> <!-- Brasília -->
              <td >${total_robo.custo}</td> <!-- Custo -->
              <td >${total_robo.leads}</td><!-- Lead's -->
              <td >${total_robo.pn}</td><!-- PN -->
              <td >${total_robo.aproveitamento}</td><!-- % -->
              <td >${total_robo.custo_lead}</td><!-- Custo Lead -->
              <td >${total_robo.custo_pn}</td><!-- Custo PN -->
              
            </tr> `;

        // Atualiza as tabelas no DOM usando jQuery
        $("#jsTableClinicas").html(html_clinica);
        $("#jsTableRobos").html(html_robo);
        $("#jsTableFooterRobos").html(html_total_robo);
        $("#jsTableFooterClinicas").html(html_total_clinica);

        break;
      }
      // =================================================== MONTA TABELA INSIGHTS CAMPANHA ===================================================

      // =================================================== MONTA TABELA INSIGHTS ROBOS ===================================================
      case "insights": {
        // Monta HTML da tabelas de insights
        let html_clinica = "",
          html_robo = "";

        // Monta tabela de insights para clínicas
        for (
          let index = 0;
          index < this.dadosTabela.INSIGHTS_CLINICA.length;
          index++
        ) {
          const dados = this.dadosTabela.INSIGHTS_CLINICA[index];
          const dadosCampCli = this.dadosTabela.CAMPANHAS_CLINICA[index];
          const dadosCampRob = this.dadosTabela.CAMPANHAS_ROBO[index];
          html_clinica += `
            <tr>
              <td >${dados.nome}</td> <!-- Brasília -->

              <td>${dadosCampCli.custo}</td> <!-- Custo -->
              <td >${dadosCampCli.leads}</td><!-- Lead's -->
              <td >${dadosCampCli.pn}</td><!-- PN -->
              <td >${dadosCampCli.aproveitamento}</td><!-- % -->
              <td >${dadosCampCli.custo_lead}</td><!-- Custo Lead -->
              <td >${dadosCampCli.custo_pn}</td><!-- Custo PN -->

              <td>${dadosCampRob.custo}</td> <!-- Custo -->
              <td >${dadosCampRob.leads}</td><!-- Lead's -->
              <td >${dadosCampRob.pn}</td><!-- PN -->
              <td >${dadosCampRob.aproveitamento}</td><!-- % -->
              <td >${dadosCampRob.custo_lead}</td><!-- Custo Lead -->
              <td >${dadosCampRob.custo_pn}</td><!-- Custo PN -->

              <td >${dados.pn_geral}</td> <!-- Brasília -->
              <td >${dados.pn_lead}</td> <!-- Custo -->
              <td >${dados.pit_geral}</td><!-- Lead's -->
              <td >${dados.pit_lead}</td><!-- PN -->
              <td >${dados.aproveitamento}</td><!-- % -->
              <td >${dados.custo_pit}</td><!-- Custo Lead -->
              <td >${dados.custo_pit_geral}</td><!-- Custo PN -->
              <td >${dados.pim}</td><!-- pim -->
              <td >${dados.fat_pim}</td><!-- FAT PIM -->
              <td >${dados.fat_pit}</td><!-- FAT PIT -->
              <td >${dados.tm_pn}</td><!-- FAT PIT -->
                <td >${dados.aproveitamento2}</td><!-- FAT PIT -->
            </tr> 
          `;
        }

        // Monta tabela de insights para robôs
        for (
          let index = 0;
          index < this.dadosTabela.INSIGHTS_ROBO.length;
          index++
        ) {
          const dados = this.dadosTabela.INSIGHTS_ROBO[index];
          html_robo += `
            <tr>
             <td >${dados.nome}</td> <!-- Brasília -->
              <td >${dados.pn_geral}</td> <!-- Brasília -->
              <td >${dados.pn_lead}</td> <!-- Custo -->
              <td >${dados.pit_geral}</td><!-- Lead's -->
              <td >${dados.pit_lead}</td><!-- PN -->
              <td >${dados.aproveitamento}</td><!-- % -->
              <td >${dados.custo_pit}</td><!-- Custo Lead -->
              <td >${dados.custo_pit_geral}</td><!-- Custo PN -->
              <td >${dados.pim}</td><!-- pim -->
              <td >${dados.fat_pim}</td><!-- FAT PIM -->
              <td >${dados.fat_pit}</td><!-- FAT PIT -->
              <td >${dados.tm_pn}</td><!-- FAT PIT -->
                <td >${dados.aproveitamento2}</td><!-- FAT PIT -->
            </tr> 
          `;
        }

        // Prepara totalizadores dos insights (clínica)
        const total_clinica = this.dadosTabela.TOTAIS_INSIGHTS_CLINICA;
        const total_clinica2 = this.dadosTabela.TOTAIS_CLINICA;
        const total_robo2 = this.dadosTabela.TOTAIS_ROBO;
        let html_total_clinica = `   <tr>
              <td >TOTAl:</td> <!-- Brasília -->

              <td >${total_clinica2.custo}</td> <!-- Custo -->
              <td >${total_clinica2.leads}</td><!-- Lead's -->
              <td >${total_clinica2.pn}</td><!-- PN -->
              <td >${total_clinica2.aproveitamento}</td><!-- % -->
              <td >${total_clinica2.custo_lead}</td><!-- Custo Lead -->
              <td >${total_clinica2.custo_pn}</td><!-- Custo PN -->

              <td >${total_robo2.custo}</td> <!-- Custo -->
              <td >${total_robo2.leads}</td><!-- Lead's -->
              <td >${total_robo2.pn}</td><!-- PN -->
              <td >${total_robo2.aproveitamento}</td><!-- % -->
              <td >${total_robo2.custo_lead}</td><!-- Custo Lead -->
              <td >${total_robo2.custo_pn}</td><!-- Custo PN -->

              <td >${total_clinica.pn_geral}</td> <!-- Brasília -->
              <td >${total_clinica.pn_lead}</td> <!-- Custo -->
              <td >${total_clinica.pit_geral}</td><!-- Lead's -->
              <td >${total_clinica.pit_lead}</td><!-- PN -->
              <td >${total_clinica.aproveitamento}</td><!-- % -->
              <td >${total_clinica.custo_pit}</td><!-- Custo Lead -->
              <td >${total_clinica.custo_pit_geral}</td><!-- Custo PN -->
              <td >${total_clinica.pim}</td><!-- pim -->
              <td >${total_clinica.fat_pim}</td><!-- FAT PIM -->
              <td >${total_clinica.fat_pit}</td><!-- FAT PIT -->
              <td >${total_clinica.tm_pn}</td><!-- FAT PIT -->
                <td >${total_clinica.aproveitamento2}</td><!-- FAT PIT -->
            </tr>  `;

        // Prepara totalizadores dos insights (robô)
        const total_robo = this.dadosTabela.TOTAIS_INSIGHTS_ROBO;
        let html_total_robo = ` <tr>
              <td >TOTAL: </td> <!-- Brasília -->
              <td >${total_robo.pn_geral}</td> <!-- Brasília -->
              <td >${total_robo.pn_lead}</td> <!-- Custo -->
              <td >${total_robo.pit_geral}</td><!-- Lead's -->
              <td >${total_robo.pit_lead}</td><!-- PN -->
              <td >${total_robo.aproveitamento}</td><!-- % -->
              <td >${total_robo.custo_pit}</td><!-- Custo Lead -->
              <td >${total_robo.custo_pit_geral}</td><!-- Custo PN -->
              <td >${total_robo.pim}</td><!-- pim -->
              <td >${total_robo.fat_pim}</td><!-- FAT PIM -->
              <td >${total_robo.fat_pit}</td><!-- FAT PIT -->
              <td >${total_robo.tm_pn}</td><!-- FAT PIT -->
                <td >${total_robo.aproveitamento2}</td><!-- FAT PIT -->
            </tr>  `;

        // Atualiza as tabelas no DOM usando jQuery
        $("#jsTableInsights").html(html_clinica);
        $("#jsTableRobosInsights").html(html_robo);
        $("#jsTableFooterRobosInsights").html(html_total_robo);
        $("#jsTableFooterInsights").html(html_total_clinica);
        setTimeout(function () {
          mountSortList('#jsMainTableInsights', '#jsTableInsights tr:first td', 1);
        }, 500);
        break;
      }
      // =================================================== MONTA TABELA INSIGHTS ROBOS ===================================================

      // =================================================== MONTA TABELA GOOGLE ===================================================
      case 'google': {
        let html_google_ads = '',
          html_google_organico = '',
          html_soma_ligacoes = 0;

        for (
          let index = 0;
          index < this.dadosTabela.GOOGLE_ADS.length;
          index++
        ) {
          const dados = this.dadosTabela.GOOGLE_ADS[index];
          html_google_ads += `
            <tr>
              <td>${dados.nome}</td>
              <td> ${this.deps.userHasRole('MANAGER') ? `${dados.impressoes}` : `<input type="text" class='form-control js-mkt-googleAdsImpressoes' value= "${dados.impressoes}" data-tipo="google_ads" data-id="${dados.id}">`}</td>
              <td> ${this.deps.userHasRole('MANAGER') ? `${dados.cliques}` : `<input type="text" class='form-control js-mkt-googleAdsCliques' value= "${dados.cliques}" data-tipo="google_ads" data-id="${dados.id}">`}</td>
              <td>${dados.cpc}</td>
              <td> ${this.deps.userHasRole('MANAGER') ? `${dados.custo}` : `<input type="text" class='form-control js-mkt-googleAdsCusto mMoney' value= "${dados.custo}" data-tipo="google_ads" data-id="${dados.id}">`}</td>
              <td> ${this.deps.userHasRole('MANAGER') ? `${dados.imp_chamadas}` : `<input type="text" class='form-control js-mkt-googleAdsImpChamadas' value= "${dados.imp_chamadas}" data-tipo="google_ads" data-id="${dados.id}">`}</td>
              <td> ${this.deps.userHasRole('MANAGER') ? `${dados.ligacoes}` : `<input type="text" class='form-control js-mkt-googleAdsLigacoes' value= "${dados.ligacoes}" data-tipo="google_ads" data-id="${dados.id}">`}</td>
            </tr>
          `;
        }

        for (
          let index = 0;
          index < this.dadosTabela.GOOGLE_ORGANICO.length;
          index++
        ) {
          const dados = this.dadosTabela.GOOGLE_ORGANICO[index];
          html_google_organico += `
            <tr>
              <td>${dados.nome}</td>
              <td> ${this.deps.userHasRole('MANAGER') ? `${dados.visualizaram_google}` : `<input type="text" class='form-control js-mkt-googleOrganicoVisualizaram' value= "${dados.visualizaram_google}" data-tipo="google_organico" data-id="${dados.id}">`}</td>
              <td> ${this.deps.userHasRole('MANAGER') ? `${dados.interacoes_perfil}` : `<input type="text" class='form-control js-mkt-googleOrganicoInteracoes' value= "${dados.interacoes_perfil}" data-tipo="google_organico" data-id="${dados.id}">`}</td>
              <td> ${this.deps.userHasRole('MANAGER') ? `${dados.ligacoes}` : `<input type="text" class='form-control js-mkt-googleOrganicoLigacoes' value= "${dados.ligacoes}" data-tipo="google_organico" data-id="${dados.id}">`}</td>
              <td> ${this.deps.userHasRole('MANAGER') ? `${dados.solicitacoes_rota}` : `<input type="text" class='form-control js-mkt-googleOrganicoSolicitacoesRota' value= "${dados.solicitacoes_rota}" data-tipo="google_organico" data-id="${dados.id}">`}</td>
              <td> ${this.deps.userHasRole('MANAGER') ? `${dados.cliques_site}` : `<input type="text" class='form-control js-mkt-googleOrganicoCliquesSite' value= "${dados.cliques_site}" data-tipo="google_organico" data-id="${dados.id}">`}</td>
            </tr>
          `;
        }

        for (
          let index = 0;
          index < this.dadosTabela.GOOGLE_SOMA_LIGACOES.length;
          index++
        ) {
          const dados = this.dadosTabela.GOOGLE_SOMA_LIGACOES[index];
          const pns = this.dadosTabela.INSIGHTS_GOOGLE_ADS[index];
          html_soma_ligacoes += `
            <tr>
              <td>${dados.nome}</td>
              <td>${dados.total}</td>
              <td>${pns.pn_google}</td>
              <td>${dados.total == 0 ? 0 : parseFloat((pns.pn_google / (dados.total)) * 100).toFixed(2)}</td>
            </tr>
          `;
        }

        const total_google_ads = this.dadosTabela.TOTAL_GOOGLE_ADS;
        let html_total_google_ads = ` <tr>
              <td >TOTAL: </td> <!-- Brasília -->
              <td >${total_google_ads.impressoes}</td> <!-- Brasília -->
              <td >${total_google_ads.cliques}</td> <!-- Custo -->
              <td >${total_google_ads.cpc}</td><!-- Lead's -->
              <td >${total_google_ads.custo}</td><!-- PN -->
              <td >${total_google_ads.imp_chamadas}</td><!-- % -->
              <td >${total_google_ads.ligacoes}</td><!-- Custo Lead -->
            </tr>  `;

        const total_google_organico = this.dadosTabela.TOTAL_GOOGLE_ORGANICO;
        let html_total_google_organico = ` <tr>
              <td >TOTAL: </td> <!-- Brasília -->
              <td >${total_google_organico.visualizaram_google}</td> <!-- Brasília -->
              <td >${total_google_organico.interacoes_perfil}</td> <!-- Custo -->
              <td >${total_google_organico.ligacoes}</td><!-- Lead's -->
              <td >${total_google_organico.solicitacoes_rota}</td><!-- PN -->
              <td >${total_google_organico.cliques_site}</td><!-- % -->
            </tr>  `;

        const total_google_soma_ligacoes = this.dadosTabela.TOTAL_GOOGLE_SOMA_LIGACOES;
        let html_google_soma_ligacoes = `<tr>
            <td>TOTAL: </td>
            <td>${total_google_soma_ligacoes.total}</td>
          </tr>`;

        $('#jsTableContentGoogleAds').html(html_google_ads);
        $('#jsTableFooterGoogleAds').html(html_total_google_ads);
        $('#jsTableContentGoogleOrganic').html(html_google_organico)
        $('#jsTableFooterGoogleOrganic').html(html_total_google_organico);
        $('#jsTableContentGoogleCallsSumContent').html(html_soma_ligacoes);
        $('#jsTableFooterGoogleCallsSumFooter').html(html_google_soma_ligacoes);

        // Monta HTML da tabelas de insights
        let html_insights_google_ads = "";

        // Monta tabela de insights para clínicas
        for (
          let index = 0;
          index < this.dadosTabela.INSIGHTS_GOOGLE_ADS.length;
          index++
        ) {
          const dados = this.dadosTabela.INSIGHTS_GOOGLE_ADS[index];
          html_insights_google_ads += `
            <tr>
              <td >${dados.nome}</td> <!-- Brasília -->
              <td >${dados.pn_geral}</td> <!-- Brasília -->
              <td >${dados.pn_google}</td> <!-- Custo -->
              <td >${dados.pit_geral}</td><!-- Lead's -->
              <td >${dados.pit_google}</td><!-- PN -->
              <td >${dados.aproveitamento}</td><!-- % -->
              <td >${dados.custo_pit}</td><!-- Custo Lead -->
              <td >${dados.custo_pit_geral}</td><!-- Custo PN -->
              <td >${dados.pim}</td><!-- pim -->
              <td >${dados.fat_pim}</td><!-- FAT PIM -->
              <td >${dados.fat_pit}</td><!-- FAT PIT -->
              <td >${dados.tm_pn}</td><!-- FAT PIT -->
                <td >${dados.aproveitamento2}</td><!-- FAT PIT -->
            </tr> 
          `;
        }

        // Prepara totalizadores dos insights (clínica)
        const total_google = this.dadosTabela.TOTAIS_INSIGHTS_GOOGLE;
        let html_total_google = `   <tr>
          <td >TOTAl:</td> <!-- Brasília -->
              <td >${total_google.pn_geral}</td> <!-- Brasília -->
              <td >${total_google.pn_google}</td> <!-- Custo -->
              <td >${total_google.pit_geral}</td><!-- Lead's -->
              <td >${total_google.pit_google}</td><!-- PN -->
              <td >${total_google.aproveitamento}</td><!-- % -->
              <td >${total_google.custo_pit}</td><!-- Custo Lead -->
              <td >${total_google.custo_pit_geral}</td><!-- Custo PN -->
              <td >${total_google.pim}</td><!-- pim -->
              <td >${total_google.fat_pim}</td><!-- FAT PIM -->
              <td >${total_google.fat_pit}</td><!-- FAT PIT -->
              <td >${total_google.tm_pn}</td><!-- FAT PIT -->
                <td >${total_google.aproveitamento2}</td><!-- FAT PIT -->
            </tr>  `;

        // Atualiza as tabelas no DOM usando jQuery
        $("#jsTableGoogleInsights").html(html_insights_google_ads);
        $("#jsTableFooterGoogleInsights").html(html_total_google);
        setTimeout(function () {
          mountSortList('#jsMainTableGoogleInsights', '#jsTableGoogleInsights tr:first td', 1);
        }, 500);
        break;
      }

      // =================================================== MONTA TABELA BANNER ===================================================
      case "banner": {
        // Inicializa variáveis para armazenar o HTML das tabelas
        let html_banner = "";

        // Monta as linhas da tabela para cada filial (clínica)
        for (
          let index = 0;
          index < this.dadosTabela.CAMPANHAS_BANNER.length;
          index++
        ) {
          const dados = this.dadosTabela.CAMPANHAS_BANNER[index];
          html_banner += `
            <tr>
              <td >${dados.nome}</td> <!-- Brasília -->
              <td> ${this.deps.userHasRole('MANAGER') ? `${dados.custo}` : `<input type="text" class='form-control js-mkt-insightsCusto mMoney' value= "${dados.custo}" data-tipo="banner" data-id="${dados.id}">`} </td> <!-- Custo -->
              <td >${this.deps.userHasRole('MANAGER') ? `${dados.leads}` : `<input type="text" class='form-control js-mkt-insightsLeads' value= "${dados.leads}" data-tipo="banner" data-id="${dados.id}">`}</td><!-- Lead's -->
              <td >${dados.pn}</td><!-- PN -->
              <td >${dados.aproveitamento}</td><!-- % -->
              <td >${dados.custo_lead}</td><!-- Custo Lead -->
              <td >${dados.custo_pn}</td><!-- Custo PN -->
              <td><button class="btn btn-sm btn-primary copy-row-btn" data-branch="${dados.nome}" data-leads="${dados.leads}" data-pn="${dados.pn}" data-aproveitamento="${dados.aproveitamento}">Copiar</button></td>
            </tr> 
          `;
        }

        // Prepara linha de totais para clínica
        const total_banner = this.dadosTabela.TOTAIS_BANNER;
        let html_total_banner = ` <tr>
              <td >TOTAL:</td> <!-- Brasília -->
              <td >${total_banner.custo}</td> <!-- Custo -->
              <td >${total_banner.leads}</td><!-- Lead's -->
              <td >${total_banner.pn}</td><!-- PN -->
              <td >${total_banner.aproveitamento}</td><!-- % -->
              <td >${total_banner.custo_lead}</td><!-- Custo Lead -->
              <td >${total_banner.custo_pn}</td><!-- Custo PN -->
              
            </tr> `;

        // Atualiza as tabelas no DOM usando jQuery
        $("#jsTableContentBannerAds").html(html_banner);
        $("#jsTableFooterBannerAds").html(html_total_banner);
        break;
      }
      case "banner_insights": {
        // Monta HTML da tabelas de insights
        let html_banner = ""

        //console.log('this.dadosTabela.INSIGHTS_BANNER', this.dadosTabela.INSIGHTS_BANNER);
        //console.log('this.dadosTabela.CAMPANHAS_BANNER', this.dadosTabela.CAMPANHAS_BANNER);

        // Monta tabela de insights para clínicas
        for (
          let index = 0;
          index < this.dadosTabela.INSIGHTS_BANNER.length;
          index++
        ) {
          const dados = this.dadosTabela.INSIGHTS_BANNER[index];
          const dadosCampBanner = this.dadosTabela.CAMPANHAS_BANNER[index];
          //console.log('dados', dados);
          //console.log('dadosCampBanner', dadosCampBanner);
          //console.log('===============================================')
          html_banner += `
            <tr>
              <td >${dados.nome}</td> <!-- Brasília -->
              <td >${dados.pn_geral}</td> <!-- Brasília -->
              <td >${dados.pn_banner}</td> <!-- Custo -->
              <td >${dados.pit_geral}</td><!-- Lead's -->
              <td >${dados.pit_banner}</td><!-- PN -->
              <td >${dados.aproveitamento}</td><!-- % -->
              <td >${dados.custo_pit}</td><!-- Custo Lead -->
              <td >${dados.custo_pit_geral}</td><!-- Custo PN -->
              <td >${dados.pim}</td><!-- pim -->
              <td >${dados.fat_pim}</td><!-- FAT PIM -->
              <td >${dados.fat_pit}</td><!-- FAT PIT -->
              <td >${dados.tm_pn}</td><!-- FAT PIT -->
                <td >${dados.aproveitamento2}</td><!-- FAT PIT -->
            </tr> 
          `;
        }

        // Prepara totalizadores dos insights (clínica)
        const total_banner = this.dadosTabela.TOTAIS_INSIGHTS_BANNER;
        let html_total_banner = `   <tr>
              <td >TOTAl:</td> <!-- Brasília -->
              <td >${total_banner.pn_geral}</td> <!-- Brasília -->
              <td >${total_banner.pn_banner}</td> <!-- Custo -->
              <td >${total_banner.pit_geral}</td><!-- Lead's -->
              <td >${total_banner.pit_banner}</td><!-- PN -->
              <td >${total_banner.aproveitamento}</td><!-- % -->
              <td >${total_banner.custo_pit}</td><!-- Custo Lead -->
              <td >${total_banner.custo_pit_geral}</td><!-- Custo PN -->
              <td >${total_banner.pim}</td><!-- pim -->
              <td >${total_banner.fat_pim}</td><!-- FAT PIM -->
              <td >${total_banner.fat_pit}</td><!-- FAT PIT -->
              <td >${total_banner.tm_pn}</td><!-- FAT PIT -->
                <td >${total_banner.aproveitamento2}</td><!-- FAT PIT -->
            </tr>  `;

        // Atualiza as tabelas no DOM usando jQuery
        $("#jsTableBannerInsights").html(html_banner);
        $("#jsTableFooterBannerInsights").html(html_total_banner);
        setTimeout(function () {
          mountSortList('#jsMainTableBannerInsights', '#jsTableBannerInsights tr:first td', 1);
        }, 500);
        break;
      }

      // =================================================== MONTA TABELA INFLUENCERS ===================================================
      case "influencer": {
        // Inicializa variáveis para armazenar o HTML das tabelas
        let html_influencer = "";

        // Monta as linhas da tabela para cada filial (clínica)
        for (
          let index = 0;
          index < this.dadosTabela.CAMPANHAS_INFLUENCERS.length;
          index++
        ) {
          const dados = this.dadosTabela.CAMPANHAS_INFLUENCERS[index];
          html_influencer += `
            <tr>
              <td >${dados.nome}</td> <!-- Brasília -->
              <td> ${this.deps.userHasRole('MANAGER') ? `${dados.custo}` : `<input type="text" class='form-control js-mkt-insightsCusto mMoney' value= "${dados.custo}" data-tipo="influencer" data-id="${dados.id}">`} </td> <!-- Custo -->
              <td >${this.deps.userHasRole('MANAGER') ? `${dados.leads}` : `<input type="text" class='form-control js-mkt-insightsLeads' value= "${dados.leads}" data-tipo="influencer" data-id="${dados.id}">`}</td><!-- Lead's -->
              <td >${dados.pn}</td><!-- PN -->
              <td >${dados.aproveitamento}</td><!-- % -->
              <td >${dados.custo_lead}</td><!-- Custo Lead -->
              <td >${dados.custo_pn}</td><!-- Custo PN -->
              <td><button class="btn btn-sm btn-primary copy-row-btn" data-branch="${dados.nome}" data-leads="${dados.leads}" data-pn="${dados.pn}" data-aproveitamento="${dados.aproveitamento}">Copiar</button></td>
            </tr> 
          `;
        }

        const total_influencer = this.dadosTabela.TOTAIS_INFLUENCERS;
        let html_total_influencer = ` <tr>
              <td >TOTAL:</td> <!-- Brasília -->
              <td >${total_influencer.custo}</td> <!-- Custo -->
              <td >${total_influencer.leads}</td><!-- Lead's -->
              <td >${total_influencer.pn}</td><!-- PN -->
              <td >${total_influencer.aproveitamento}</td><!-- % -->
              <td >${total_influencer.custo_lead}</td><!-- Custo Lead --> 
              <td >${total_influencer.custo_pn}</td><!-- Custo PN -->
              
            </tr> `;

        // Atualiza as tabelas no DOM usando jQuery
        $("#jsTableContentInfluencerAds").html(html_influencer);
        $("#jsTableFooterInfluencerAds").html(html_total_influencer);
        break;
      }
      case "influencer_insights": {
        // Monta HTML da tabelas de insights
        let html_influencer = ""

        // Monta tabela de insights para clínicas
        for (
          let index = 0;
          index < this.dadosTabela.INSIGHTS_INFLUENCERS.length;
          index++
        ) {
          const dados = this.dadosTabela.INSIGHTS_INFLUENCERS[index];
          const dadosCampInfluencer = this.dadosTabela.CAMPANHAS_INFLUENCERS[index];
          html_influencer += `
            <tr>
              <td >${dados.nome}</td> <!-- Brasília -->
              <td >${dados.pn_geral}</td> <!-- Brasília -->
              <td >${dados.pn_influencer}</td> <!-- Custo -->
              <td >${dados.pit_geral}</td><!-- Lead's -->
              <td >${dados.pit_influencer}</td><!-- PN -->
              <td >${dados.aproveitamento}</td><!-- % -->
              <td >${dados.custo_pit}</td><!-- Custo Lead -->
              <td >${dados.custo_pit_geral}</td><!-- Custo PN -->
              <td >${dados.pim}</td><!-- pim -->
              <td >${dados.fat_pim}</td><!-- FAT PIM -->
              <td >${dados.fat_pit}</td><!-- FAT PIT -->
              <td >${dados.tm_pn}</td><!-- FAT PIT -->
                <td >${dados.aproveitamento2}</td><!-- FAT PIT -->
            </tr> 
          `;
        }

        // Prepara totalizadores dos insights (clínica)
        const total_influencer = this.dadosTabela.TOTAIS_INSIGHTS_INFLUENCERS;
        let html_total_influencer = `   <tr>
              <td >TOTAl:</td> <!-- Brasília -->

              <td >${total_influencer.pn_geral}</td> <!-- Brasília -->
              <td >${total_influencer.pn_influencer}</td> <!-- Custo -->
              <td >${total_influencer.pit_geral}</td><!-- Lead's -->
              <td >${total_influencer.pit_influencer}</td><!-- PN -->
              <td >${total_influencer.aproveitamento}</td><!-- % -->
              <td >${total_influencer.custo_pit}</td><!-- Custo Lead -->
              <td >${total_influencer.custo_pit_geral}</td><!-- Custo PN -->
              <td >${total_influencer.pim}</td><!-- pim -->
              <td >${total_influencer.fat_pim}</td><!-- FAT PIM -->
              <td >${total_influencer.fat_pit}</td><!-- FAT PIT -->
              <td >${total_influencer.tm_pn}</td><!-- FAT PIT -->
              <td >${total_influencer.aproveitamento2}</td><!-- FAT PIT -->
            </tr>  `;

        // Atualiza as tabelas no DOM usando jQuery
        $("#jsTableInfluencerInsights").html(html_influencer);
        $("#jsTableFooterInfluencerInsights").html(html_total_influencer);
        setTimeout(function () {
          mountSortList('#jsMainTableInfluencerInsights', '#jsTableInfluencerInsights tr:first td', 1);
        }, 500);
        break;
      }

      // =================================================== MONTA TABELA DISPAROS

      case "disparos": {
        let html_disparos = "";

        let disparos = this.dadosTabela.DISPAROS;

        let retornoTotal = disparos.retorno_em_contratos + disparos.retorno_em_avaliacoes - disparos.investimento_total;

        html_disparos += `
          <tr>
            <td>${this.deps.userHasRole('MANAGER') ? `${disparos.investimento_total}` : `<input type="text" class='form-control js-mkt-disparosInvestimentoTotal mMoney' value= "${float2moeda(disparos.investimento_total)}" data-tipo="disparos" data-id="${disparos.id}">`}</td>
            <td>${this.deps.userHasRole('MANAGER') ? `${disparos.total_contratos}` : `<input type="number" class='form-control js-mkt-disparosTotalContratos' value= "${disparos.total_contratos}" data-tipo="disparos" data-id="${disparos.id}">`}</td>
            <td>${this.deps.userHasRole('MANAGER') ? `${disparos.total_avaliacoes}` : `<input type="number" class='form-control js-mkt-disparosTotalAvaliacoes' value= "${disparos.total_avaliacoes}" data-tipo="disparos" data-id="${disparos.id}">`}</td>
            <td>${this.deps.userHasRole('MANAGER') ? `${disparos.retorno_em_contratos}` : `<input type="text" class='form-control js-mkt-disparosRetornoEmContratos mMoney' value= "${float2moeda(disparos.retorno_em_contratos)}" data-tipo="disparos" data-id="${disparos.id}">`}</td>
            <td>${this.deps.userHasRole('MANAGER') ? `${disparos.retorno_em_avaliacoes}` : `<input type="text" class='form-control js-mkt-disparosRetornoEmAvaliacoes mMoney' value= "${float2moeda(disparos.retorno_em_avaliacoes)}" data-tipo="disparos" data-id="${disparos.id}">`}</td>
            <td>${float2moeda(retornoTotal)}</td>
          </tr>
        `;

        $("#jsTableContentDisparo").html(html_disparos);

        break;
      }

      // =================================================== MONTA TABELA CHATWOOT
      case "chatwoot": {
        let html_chatwoot = "";

        for (
          let index = 0;
          index < this.dadosTabela.CHATWOOT.length;
          index++
        ) {
          const dados = this.dadosTabela.CHATWOOT[index];
          html_chatwoot += `
            <tr>
              <td>${dados.nome}</td>
              <td>${this.deps.userHasRole('MANAGER') ? `${dados.custo}` : `<input type="text" class='form-control js-mkt-chatwootGasto mMoney' value="${dados.custo}" data-tipo="chatwoot" data-id="${dados.id}">`}</td>
            </tr>
          `;
        }

        const total_chatwoot = this.dadosTabela.TOTAL_CHATWOOT;
        let html_total_chatwoot = `
          <tr>
            <td>TOTAL:</td>
            <td>${total_chatwoot.custo}</td>
          </tr>
        `;

        $("#jsTableContentChatwoot").html(html_chatwoot);
        $("#jsTableFooterChatwoot").html(html_total_chatwoot);
        break;
      }

      // ========================= MONTA TABELA META GERAL ===========================================
      case "meta_geral": {
        // Monta HTML da tabela de meta geral
        let html_meta_geral = "";

        let saveBranchClinicAndHunterData = [];
        let saveBranchClinicAndHunterSums = {
          clinic: {
            'approveitamento': 0,
            'custo': 0,
            'custo_lead': 0,
            'custo_pn': 0,
            'leads': 0,
            'pn': 0
          },
          hunter: {
            'approveitamento': 0,
            'custo': 0,
            'custo_lead': 0,
            'custo_pn': 0,
            'leads': 0,
            'pn': 0
          },
        };

        // Monta tabela de meta geral para clínicas
        for (let index = 0; index < this.dadosTabela.CAMPANHAS_CLINICA.length; index++) {
          const dados = this.dadosTabela.CAMPANHAS_CLINICA[index];
          const dadosHunter = this.dadosTabela.CAMPANHAS_ROBO[index];
          if (!saveBranchClinicAndHunterData[dados.id]) {
            saveBranchClinicAndHunterData[dados.id] = {
              clinic: dados,
              hunter: dadosHunter,
            };
          }
        }

        let totalKeys = Object.keys(saveBranchClinicAndHunterData);
        for (let index = 0; index < totalKeys.length; index++) {
          const key = totalKeys[index];
          const dados = saveBranchClinicAndHunterData[key];


          let clinicInvestimentoFloat = isNaN(dados.clinic.custo) || typeof dados.clinic.custo === 'string' ? Number(currencyToFloat(dados.clinic.custo)) : dados.clinic.custo;
          let hunterInvestimentoFloat = isNaN(dados.hunter.custo) || typeof dados.hunter.custo === 'string' ? Number(currencyToFloat(dados.hunter.custo)) : dados.hunter.custo;

          let clinicAproveitamentoSemPorcentagem = isNaN(dados.clinic.aproveitamento) || typeof dados.clinic.aproveitamento === 'string' ? Number(parseFloat(dados.clinic.aproveitamento.replace('%', '')).toFixed(2)) : dados.clinic.aproveitamento;
          let hunterAproveitamentoSemPorcentagem = isNaN(dados.hunter.aproveitamento) || typeof dados.hunter.aproveitamento === 'string' ? Number(parseFloat(dados.hunter.aproveitamento.replace('%', '')).toFixed(2)) : dados.hunter.aproveitamento;

          let clinicCustoLeadSemMoeda = isNaN(dados.clinic.custo_lead) || typeof dados.clinic.custo_lead === 'string' ? Number(parseFloat(dados.clinic.custo_lead.replace('R$ ', '')).toFixed(2)) : dados.clinic.custo_lead;
          clinicCustoLeadSemMoeda = isNaN(dados.clinic.custo_lead) || typeof dados.clinic.custo_lead === 'string' ? Number(parseFloat(dados.clinic.custo_lead.replace('R$', '')).toFixed(2)) : dados.clinic.custo_lead;
          let hunterCustoLeadSemMoeda = isNaN(dados.hunter.custo_lead) || typeof dados.hunter.custo_lead === 'string' ? Number(parseFloat(dados.hunter.custo_lead.replace('R$ ', '')).toFixed(2)) : dados.hunter.custo_lead;
          hunterCustoLeadSemMoeda = isNaN(dados.hunter.custo_lead) || typeof dados.hunter.custo_lead === 'string' ? Number(parseFloat(dados.hunter.custo_lead.replace('R$', '')).toFixed(2)) : dados.hunter.custo_lead;

          let clinicCustoPNSemMoeda = isNaN(dados.clinic.custo_pn) || typeof dados.clinic.custo_pn === 'string' ? Number(parseFloat(dados.clinic.custo_pn.replace('R$', '').replace('R$', '.').replace(',', '.')).toFixed(2)) : dados.clinic.custo_pn;
          let hunterCustoPNSemMoeda = isNaN(dados.hunter.custo_pn) || typeof dados.hunter.custo_pn === 'string' ? Number(parseFloat(dados.hunter.custo_pn.replace('R$', '').replace('R$', '.').replace(',', '.')).toFixed(2)) : dados.hunter.custo_pn;

          saveBranchClinicAndHunterSums.clinic.approveitamento += clinicAproveitamentoSemPorcentagem;
          saveBranchClinicAndHunterSums.clinic.custo += clinicInvestimentoFloat;
          saveBranchClinicAndHunterSums.clinic.custo_lead += clinicCustoLeadSemMoeda;
          saveBranchClinicAndHunterSums.clinic.custo_pn += clinicCustoPNSemMoeda;
          saveBranchClinicAndHunterSums.clinic.leads += dados.clinic.leads;
          saveBranchClinicAndHunterSums.clinic.pn += dados.clinic.pn;

          saveBranchClinicAndHunterSums.hunter.approveitamento += hunterAproveitamentoSemPorcentagem;
          saveBranchClinicAndHunterSums.hunter.custo += hunterInvestimentoFloat;
          saveBranchClinicAndHunterSums.hunter.custo_lead += hunterCustoLeadSemMoeda;
          saveBranchClinicAndHunterSums.hunter.custo_pn += hunterCustoPNSemMoeda;
          saveBranchClinicAndHunterSums.hunter.leads += dados.hunter.leads;
          saveBranchClinicAndHunterSums.hunter.pn += dados.hunter.pn;

          console.log('dados', dados, clinicInvestimentoFloat, hunterInvestimentoFloat);

          html_meta_geral += `
            <tr>
                <td rowspan="3" class="align-middle fw-bold">${dados.clinic.nome}</td>
                <td>CLINICA</td>
                <td>R$</td>
                <td class="text-end">${clinicInvestimentoFloat}</td>
                <td class="text-end">${dados.clinic.leads}</td>
                <td class="text-end">${dados.clinic.pn}</td>
                <td class="text-end">${dados.clinic.aproveitamento}</td>
                <td>R$</td>
                <td class="text-end">${dados.clinic.custo_lead}</td>
                <td class="text-danger">R$</td>
                <td class="text-danger text-end fw-bold">${dados.clinic.custo_pn}</td>
            </tr>
            <tr>
                <td>ROBO</td>
                <td>R$</td>
                <td class="text-end">${hunterInvestimentoFloat}</td>
                <td class="text-end">${dados.hunter.leads}</td>
                <td class="text-end">${dados.hunter.pn}</td>
                <td class="text-end">${dados.hunter.aproveitamento}</td>
                <td>R$</td>
                <td class="text-end">${dados.hunter.custo_lead}</td>
                <td class="text-danger">R$</td>
                <td class="text-danger text-end fw-bold">${dados.hunter.custo_pn}</td>
            </tr>
            <tr class="table-info">
                <td class="fw-bold">TOTAL</td>
                <td>R$</td>
                <td class="text-end fw-bold">${(clinicInvestimentoFloat + hunterInvestimentoFloat).toFixed(2)}</td>
                <td class="text-end fw-bold">${dados.clinic.leads + dados.hunter.leads}</td>
                <td class="text-end fw-bold">${dados.clinic.pn + dados.hunter.pn}</td>
                <td class="text-end fw-bold">${dados.clinic.leads + dados.hunter.leads == 0 ? 0 : parseFloat(((dados.clinic.pn + dados.hunter.pn) / (dados.clinic.leads + dados.hunter.leads) * 100)).toFixed(2)}%</td>
                <td>R$</td>
                <td class="text-end fw-bold">${dados.clinic.leads + dados.hunter.leads == 0 ? 0 : parseFloat(((clinicInvestimentoFloat + hunterInvestimentoFloat) / (dados.clinic.leads + dados.hunter.leads)).toFixed(2))}</td>
                <td class="text-danger">R$</td>
                <td class="text-danger text-end fw-bold">${dados.clinic.pn + dados.hunter.pn == 0 ? 0 : parseFloat(((clinicInvestimentoFloat + hunterInvestimentoFloat) / (dados.clinic.pn + dados.hunter.pn)).toFixed(2))}</td>
            </tr>
          `;
        }

        $("#jsTableClinicasGeral").html(html_meta_geral);

        console.log('saveBranchClinicAndHunterSums', saveBranchClinicAndHunterSums);

        let html_total_clinicas_geral = "";
        html_total_clinicas_geral += `
            <tr>
                <td rowspan="4" class="align-middle fw-bold">TOTAL</td>
                <th>RESP.</th>
                <th colspan="2">R$ Investimento</th>
                <th>Lead</th>
                <th>PNs</th>
                <th>Aprov. Lead%</th>
                <th colspan="2">CAC Lead</th>
                <th colspan="2">CAC PN</th>
            <tr>
            <tr>
                <td>CLINICA</td>
                <td>R$</td>
                <td class="text-end">${(saveBranchClinicAndHunterSums.clinic.custo).toFixed(2)}</td>
                <td class="text-end">${saveBranchClinicAndHunterSums.clinic.leads}</td>
                <td class="text-end">${saveBranchClinicAndHunterSums.clinic.pn}</td>
                <td class="text-end">${(saveBranchClinicAndHunterSums.clinic.leads == 0 ? 0 : parseFloat(((saveBranchClinicAndHunterSums.clinic.pn) / (saveBranchClinicAndHunterSums.clinic.leads) * 100)).toFixed(2))}%</td>
                <td>R$</td>
                <td class="text-end">${saveBranchClinicAndHunterSums.clinic.leads == 0 ? 0 : parseFloat(((saveBranchClinicAndHunterSums.clinic.custo) / (saveBranchClinicAndHunterSums.clinic.leads)).toFixed(2))}</td>
                <td class="">R$</td>
                <td class="text-end fw-bold">${saveBranchClinicAndHunterSums.clinic.pn == 0 ? 0 : parseFloat(((saveBranchClinicAndHunterSums.clinic.custo) / (saveBranchClinicAndHunterSums.clinic.pn)).toFixed(2))}</td>
            </tr>
            <tr>
                <td>ROBO</td>
                <td>R$</td>
                <td class="text-end">${(saveBranchClinicAndHunterSums.hunter.custo).toFixed(2)}</td>
                <td class="text-end">${saveBranchClinicAndHunterSums.hunter.leads}</td>
                <td class="text-end">${saveBranchClinicAndHunterSums.hunter.pn}</td>
                <td class="text-end">${(saveBranchClinicAndHunterSums.hunter.leads == 0 ? 0 : parseFloat(((saveBranchClinicAndHunterSums.hunter.pn) / (saveBranchClinicAndHunterSums.hunter.leads) * 100)).toFixed(2))}%</td>
                <td>R$</td>
                <td class="text-end">${saveBranchClinicAndHunterSums.hunter.leads == 0 ? 0 : parseFloat(((saveBranchClinicAndHunterSums.hunter.custo) / (saveBranchClinicAndHunterSums.hunter.leads)).toFixed(2))}</td>
                <td class="">R$</td>
                <td class="text-end fw-bold">${saveBranchClinicAndHunterSums.hunter.pn == 0 ? 0 : parseFloat(((saveBranchClinicAndHunterSums.hunter.custo) / (saveBranchClinicAndHunterSums.hunter.pn)).toFixed(2))}</td>
            </tr>
            <tr class="table-info">
                <td colspan="2" class="fw-bold">TOTAL</td>
                <td>R$</td>
                <td class="text-end fw-bold">${(saveBranchClinicAndHunterSums.clinic.custo + saveBranchClinicAndHunterSums.hunter.custo).toFixed(2)}</td>
                <td class="text-end fw-bold">${saveBranchClinicAndHunterSums.clinic.leads + saveBranchClinicAndHunterSums.hunter.leads}</td>
                <td class="text-end fw-bold">${saveBranchClinicAndHunterSums.clinic.pn + saveBranchClinicAndHunterSums.hunter.pn}</td>
                <td class="text-end fw-bold">${saveBranchClinicAndHunterSums.clinic.leads + saveBranchClinicAndHunterSums.hunter.leads == 0 ? 0 : parseFloat(((saveBranchClinicAndHunterSums.clinic.pn + saveBranchClinicAndHunterSums.hunter.pn) / (saveBranchClinicAndHunterSums.clinic.leads + saveBranchClinicAndHunterSums.hunter.leads) * 100)).toFixed(2)}%</td>
                <td>R$</td>
                <td class="text-end fw-bold">${saveBranchClinicAndHunterSums.clinic.leads + saveBranchClinicAndHunterSums.hunter.leads == 0 ? 0 : parseFloat(((saveBranchClinicAndHunterSums.clinic.custo + saveBranchClinicAndHunterSums.hunter.custo) / (saveBranchClinicAndHunterSums.clinic.leads + saveBranchClinicAndHunterSums.hunter.leads)).toFixed(2))}</td>
                <td class="">R$</td>
                <td class="text-end fw-bold">${saveBranchClinicAndHunterSums.clinic.pn + saveBranchClinicAndHunterSums.hunter.pn == 0 ? 0 : parseFloat(((saveBranchClinicAndHunterSums.clinic.custo + saveBranchClinicAndHunterSums.hunter.custo) / (saveBranchClinicAndHunterSums.clinic.pn + saveBranchClinicAndHunterSums.hunter.pn)).toFixed(2))}</td>
            </tr>
          `;

        $('#jsTableFooterClinicasGeral').html(html_total_clinicas_geral);

        console.log('html_meta_geral', html_meta_geral);
        console.log('saveBranchClinicAndHunterData', saveBranchClinicAndHunterData);
      }
    }
  }

  // =================== Busca dados no backend
  buscarDados() {
    let self = this;
    if (this.fetchRequest) {
      if (typeof this.fetchRequest.abort === 'function')
        this.fetchRequest.abort();
      this.fetchRequest = null;
    }// else {
    $('.js-mkt-insights-content').block(window._loader.loading);
    //}

    if (this.tipoRelatorio == 'meta') {
      $('.js-mkt-insights-source').html('Meta Ads');
    } else if (this.tipoRelatorio == 'google') {
      $('.js-mkt-insights-source').html('Google Ads');
    } else if (this.tipoRelatorio == 'banner') {
      $('.js-mkt-insights-source').html('Banner Ads');
    } else if (this.tipoRelatorio == 'influencer') {
      $('.js-mkt-insights-source').html('Influencer Ads');
    } else if (this.tipoRelatorio == 'disparo') {
      $('.js-mkt-insights-source').html('Disparos');
    } else if (this.tipoRelatorio == 'chatwoot') {
      $('.js-mkt-insights-source').html('Gasto Chatwoot');
    }

    if (this.somaMesAtual) {
      $('.js-mkt-insights-string-date').html('do mês ' + this.dataFiltro + '');
    } else {
      $('.js-mkt-insights-string-date').html('da data ' + this.dataFiltro + '' + (this.dataFiltroFim != this.dataFiltro ? ' até ' + this.dataFiltroFim : ''));
    }

    this.fetchRequest = this.deps.apiCall({
      method: "GET",
      endpoint: "api/v1/marketing/insights",
      data: {
        date: this.dataFiltro,
        dateEnd: this.dataFiltroFim,
        report: "PAGE_MARKETING_METRICS_INSIGHTS",
        source: this.tipoRelatorio,
        sumMonth: this.somaMesAtual,
        franchise: this.onlyFranchise
      },
      successCallback: (resposta) => {
        self.dadosTabela = resposta.results;
        if (self.tipoRelatorio == 'meta') {
          self.montarTabela("campanha");
          self.montarTabela("insights");
          self.montarTabela("meta_geral");
        } else if (self.tipoRelatorio == 'google') {
          self.montarTabela("google");
        } else if (self.tipoRelatorio == 'banner') {
          self.montarTabela("banner");
          self.montarTabela("banner_insights");
        } else if (self.tipoRelatorio == 'influencer') {
          self.montarTabela("influencer");
          self.montarTabela("influencer_insights");
        } else if (self.tipoRelatorio == 'disparo') {
          self.montarTabela("disparos");
        } else if (self.tipoRelatorio == 'chatwoot') {
          self.montarTabela("chatwoot");
        }
        console.log(resposta);
        $('.js-mkt-insights-content').unblock(window._loader.loading);
      },
      errorCallback: (erro) => {
        console.error(erro);
        //$('.js-mkt-insights-content').unblock(window._loader.loading);
      },
    });
  }

  // =================== Detecta ações do usuário em elementos da página
  detectarAlteracoes() {
    let self = this;
    $(document).on("change", ".js-mkt-insightsCusto", function () {
      let tipo = $(this).data("tipo");
      let id = $(this).data("id");
      let valor = moeda2float($(this).val());
      if (tipo == "clinica" || tipo == 'robo') {
        if (tipo == "clinica") {
          for (let i = 0; i < self.dadosTabela.CAMPANHAS_CLINICA.length; ++i) {
            let informacao = self.dadosTabela.CAMPANHAS_CLINICA[i];
            if (informacao.id == id) {
              self.dadosTabela.CAMPANHAS_CLINICA[i].custo = valor;
            }
          }
        } else {
          for (let i = 0; i < self.dadosTabela.CAMPANHAS_ROBO.length; ++i) {
            let informacao = self.dadosTabela.CAMPANHAS_ROBO[i];
            if (informacao.id == id) {
              self.dadosTabela.CAMPANHAS_ROBO[i].custo = valor;
            }
          }
        }
      } else if (tipo == 'banner') {
        for (let i = 0; i < self.dadosTabela.CAMPANHAS_BANNER.length; ++i) {
          let informacao = self.dadosTabela.CAMPANHAS_BANNER[i];
          if (informacao.id == id) {
            self.dadosTabela.CAMPANHAS_BANNER[i].custo = valor;
          }
        }
      } else if (tipo == 'influencer') {
        for (let i = 0; i < self.dadosTabela.CAMPANHAS_INFLUENCERS.length; ++i) {
          let informacao = self.dadosTabela.CAMPANHAS_INFLUENCERS[i];
          if (informacao.id == id) {
            self.dadosTabela.CAMPANHAS_INFLUENCERS[i].custo = valor;
          }
        }
      }
      //console.log($(this).val(), tipo, id);
    });

    $(document).on("change", ".js-mkt-insightsLeads", function () {
      let tipo = $(this).data("tipo");
      let id = $(this).data("id");
      let valor = $(this).val();
      if (tipo == "clinica" || tipo == 'robo') {
        if (tipo == "clinica") {
          for (let i = 0; i < self.dadosTabela.CAMPANHAS_CLINICA.length; ++i) {
            let informacao = self.dadosTabela.CAMPANHAS_CLINICA[i];
            if (informacao.id == id) {
              self.dadosTabela.CAMPANHAS_CLINICA[i].leads = valor;
            }
          }
        } else {
          for (let i = 0; i < self.dadosTabela.CAMPANHAS_ROBO.length; ++i) {
            let informacao = self.dadosTabela.CAMPANHAS_ROBO[i];
            if (informacao.id == id) {
              self.dadosTabela.CAMPANHAS_ROBO[i].leads = valor;
            }
          }
        }
      } else if (tipo == 'banner') {
        for (let i = 0; i < self.dadosTabela.CAMPANHAS_BANNER.length; ++i) {
          let informacao = self.dadosTabela.CAMPANHAS_BANNER[i];
          if (informacao.id == id) {
            self.dadosTabela.CAMPANHAS_BANNER[i].leads = valor;
          }
        }
      } else if (tipo == 'influencer') {
        for (let i = 0; i < self.dadosTabela.CAMPANHAS_INFLUENCERS.length; ++i) {
          let informacao = self.dadosTabela.CAMPANHAS_INFLUENCERS[i];
          if (informacao.id == id) {
            self.dadosTabela.CAMPANHAS_INFLUENCERS[i].leads = valor;
          }
        }
      }
      //console.log($(this).val(), tipo, id);
    });

    $(document).on("change", ".js-mkt-googleAdsImpressoes", function () {
      let tipo = $(this).data("tipo");
      let id = $(this).data("id");
      let valor = $(this).val();
      for (let i = 0; i < self.dadosTabela.GOOGLE_ADS.length; ++i) {
        let informacao = self.dadosTabela.GOOGLE_ADS[i];
        if (informacao.id == id) {
          self.dadosTabela.GOOGLE_ADS[i].impressoes = valor;
        }
      }
      //console.log($(this).val(), tipo, id);
    });

    $(document).on("paste", ".js-mkt-googleAdsImpressoes", function (e) {
      e.preventDefault();
      const pastedData = event.clipboardData.getData("text");
      let id = $(this).data("id");

      // Split and parse the pasted data
      const processedData = pastedData.split(/\s+/).map(value => {
        const normalizedValue = value.replace(",", "."); // Replace ',' with '.'
        return parseFloat(normalizedValue); // Convert to a number
      });

      if (processedData.length >= 4) {
        $('.js-mkt-googleAdsImpressoes[data-id="' + id + '"]').val(processedData[0]);
        $('.js-mkt-googleAdsCliques[data-id="' + id + '"]').val(processedData[1]);
        $('.js-mkt-googleAdsCusto[data-id="' + id + '"]').val(float2moeda(processedData[3]));
        $('.js-mkt-googleAdsImpChamadas[data-id="' + id + '"]').val(processedData[4]);
        $('.js-mkt-googleAdsLigacoes[data-id="' + id + '"]').val(processedData[5]);

        $('.js-mkt-googleAdsImpressoes[data-id="' + id + '"]').trigger('change');
        $('.js-mkt-googleAdsCliques[data-id="' + id + '"]').trigger('change');
        $('.js-mkt-googleAdsCusto[data-id="' + id + '"]').trigger('change');
        $('.js-mkt-googleAdsImpChamadas[data-id="' + id + '"]').trigger('change');
        $('.js-mkt-googleAdsLigacoes[data-id="' + id + '"]').trigger('change');
      }
    });

    $(document).on("change", ".js-mkt-googleAdsCliques", function () {
      let tipo = $(this).data("tipo");
      let id = $(this).data("id");
      let valor = $(this).val();
      for (let i = 0; i < self.dadosTabela.GOOGLE_ADS.length; ++i) {
        let informacao = self.dadosTabela.GOOGLE_ADS[i];
        if (informacao.id == id) {
          self.dadosTabela.GOOGLE_ADS[i].cliques = valor;
        }
      }
      //console.log($(this).val(), tipo, id);
    });

    $(document).on("change", ".js-mkt-googleAdsCpc", function () {
      let tipo = $(this).data("tipo");
      let id = $(this).data("id");
      let valor = $(this).val();
      for (let i = 0; i < self.dadosTabela.GOOGLE_ADS.length; ++i) {
        let informacao = self.dadosTabela.GOOGLE_ADS[i];
        if (informacao.id == id) {
          self.dadosTabela.GOOGLE_ADS[i].cpc = valor;
        }
      }
      //console.log($(this).val(), tipo, id);
    });

    $(document).on("change", ".js-mkt-googleAdsCusto", function () {
      let tipo = $(this).data("tipo");
      let id = $(this).data("id");
      let valor = moeda2float($(this).val());
      for (let i = 0; i < self.dadosTabela.GOOGLE_ADS.length; ++i) {
        let informacao = self.dadosTabela.GOOGLE_ADS[i];
        if (informacao.id == id) {
          self.dadosTabela.GOOGLE_ADS[i].custo = valor;
        }
      }
      //console.log($(this).val(), tipo, id);
    });

    $(document).on("change", ".js-mkt-googleAdsImpChamadas", function () {
      let tipo = $(this).data("tipo");
      let id = $(this).data("id");
      let valor = $(this).val();
      for (let i = 0; i < self.dadosTabela.GOOGLE_ADS.length; ++i) {
        let informacao = self.dadosTabela.GOOGLE_ADS[i];
        if (informacao.id == id) {
          self.dadosTabela.GOOGLE_ADS[i].imp_chamadas = valor;
        }
      }
      //console.log($(this).val(), tipo, id);
    });

    $(document).on("change", ".js-mkt-googleAdsLigacoes", function () {
      let tipo = $(this).data("tipo");
      let id = $(this).data("id");
      let valor = $(this).val();
      for (let i = 0; i < self.dadosTabela.GOOGLE_ADS.length; ++i) {
        let informacao = self.dadosTabela.GOOGLE_ADS[i];
        if (informacao.id == id) {
          self.dadosTabela.GOOGLE_ADS[i].ligacoes = valor;
        }
      }
      //console.log($(this).val(), tipo, id);
    });

    $(document).on("change", ".js-mkt-googleOrganicoVisualizaram", function () {
      let tipo = $(this).data("tipo");
      let id = $(this).data("id");
      let valor = $(this).val();
      for (let i = 0; i < self.dadosTabela.GOOGLE_ORGANICO.length; ++i) {
        let informacao = self.dadosTabela.GOOGLE_ORGANICO[i];
        if (informacao.id == id) {
          self.dadosTabela.GOOGLE_ORGANICO[i].visualizaram_google = valor;
        }
      }
      //console.log($(this).val(), tipo, id);
    });

    $(document).on("change", ".js-mkt-googleOrganicoInteracoes", function () {
      let tipo = $(this).data("tipo");
      let id = $(this).data("id");
      let valor = $(this).val();
      for (let i = 0; i < self.dadosTabela.GOOGLE_ORGANICO.length; ++i) {
        let informacao = self.dadosTabela.GOOGLE_ORGANICO[i];
        if (informacao.id == id) {
          self.dadosTabela.GOOGLE_ORGANICO[i].interacoes_perfil = valor;
        }
      }
      //console.log($(this).val(), tipo, id);
    });

    $(document).on("change", ".js-mkt-googleOrganicoLigacoes", function () {
      let tipo = $(this).data("tipo");
      let id = $(this).data("id");
      let valor = $(this).val();
      for (let i = 0; i < self.dadosTabela.GOOGLE_ORGANICO.length; ++i) {
        let informacao = self.dadosTabela.GOOGLE_ORGANICO[i];
        if (informacao.id == id) {
          self.dadosTabela.GOOGLE_ORGANICO[i].ligacoes = valor;
        }
      }
      //console.log($(this).val(), tipo, id);
    });

    $(document).on("change", ".js-mkt-googleOrganicoSolicitacoesRota", function () {
      let tipo = $(this).data("tipo");
      let id = $(this).data("id");
      let valor = $(this).val();
      for (let i = 0; i < self.dadosTabela.GOOGLE_ORGANICO.length; ++i) {
        let informacao = self.dadosTabela.GOOGLE_ORGANICO[i];
        if (informacao.id == id) {
          self.dadosTabela.GOOGLE_ORGANICO[i].solicitacoes_rota = valor;
        }
      }
      //console.log($(this).val(), tipo, id);
    });

    $(document).on("change", ".js-mkt-googleOrganicoCliquesSite", function () {
      let tipo = $(this).data("tipo");
      let id = $(this).data("id");
      let valor = $(this).val();
      for (let i = 0; i < self.dadosTabela.GOOGLE_ORGANICO.length; ++i) {
        let informacao = self.dadosTabela.GOOGLE_ORGANICO[i];
        if (informacao.id == id) {
          self.dadosTabela.GOOGLE_ORGANICO[i].cliques_site = valor;
        }
      }
      //console.log($(this).val(), tipo, id);
    });

    $(document).on("change", ".js-mkt-disparosInvestimentoTotal", function () {
      let valor = $(this).val();
      self.dadosTabela.DISPAROS.investimento_total = valor;
      //console.log($(this).val(), tipo, id);
    });

    $(document).on("change", ".js-mkt-disparosTotalContratos", function () {
      let valor = $(this).val();
      self.dadosTabela.DISPAROS.total_contratos = valor;
      //console.log($(this).val(), tipo, id);
    });

    $(document).on("change", ".js-mkt-disparosTotalAvaliacoes", function () {
      let valor = $(this).val();
      self.dadosTabela.DISPAROS.total_avaliacoes = valor;
      //console.log($(this).val(), tipo, id);
    });

    $(document).on("change", ".js-mkt-disparosRetornoEmContratos", function () {
      let valor = $(this).val();
      self.dadosTabela.DISPAROS.retorno_em_contratos = valor;
      //console.log($(this).val(), tipo, id);
    });

    $(document).on("change", ".js-mkt-disparosRetornoEmAvaliacoes", function () {
      let valor = $(this).val();
      self.dadosTabela.DISPAROS.retorno_em_avaliacoes = valor;
      //console.log($(this).val(), tipo, id);
    });

    $(document).on("click", ".js-mkt-salvar", function () {
      if (window.confirm("Você tem certeza que você quer salvar? 😮")) {
        $('.js-mkt-insights-content').block(window._loader.loading);
        apiCall({
          method: "PUT",
          endpoint: "api/v1/marketing/publish-marketing-metrics",
          data: {
            date: self.dataFiltro,
            table_info: self.dadosTabela,
            source: self.tipoRelatorio
          },
          successCallback: (res) => {
            //$('.js-mkt-insights-content').unblock(window._loader.loading);
            if (!res.error) {
              window.toast({ error: false, text: "Salvo com sucesso! 😙" });
              self.buscarDados();
            } else {
              window.toast({ error: true, text: res.message });
              $('.js-mkt-insights-content').unblock(window._loader.loading);
            }
          },
          errorCallback: () => {
            $('.js-mkt-insights-content').unblock(window._loader.loading);
            window.toast({ error: true, text: "Ocorreu um erro 😭 " });
          },
        });
      }
    });

    $(document).on('change', "#filtrarData", function () {
      let data = $(this).val();
      self.dataFiltro = data;
      self.buscarDados();
    });

    $(document).on('change', "#filtrarDataFim", function () {
      let data = $(this).val();
      self.dataFiltroFim = data;
      self.buscarDados();
    });

    $(document).on("change", ".js-mkt-chatwootGasto", function () {
      let id = $(this).data("id");
      let valor = moeda2float($(this).val());
      for (let i = 0; i < self.dadosTabela.CHATWOOT.length; ++i) {
        let informacao = self.dadosTabela.CHATWOOT[i];
        if (informacao.id == id) {
          self.dadosTabela.CHATWOOT[i].custo = valor;
        }
      }
    });

    $(document).on('click', '.mkt-insights-meta-ads-tab,.mkt-insights-google-ads-tab,.mkt-insights-banner-ads-tab,.mkt-insights-influencer-ads-tab,.mkt-insights-disparo-ads-tab,.mkt-insights-chatwoot-tab', function () {
      self.tipoRelatorio = $(this).data('type');
      self.buscarDados();
    });

    $(document).on('click', '#somarMesSelecionado', function () {
      let isChecked = $(this).is(':checked');
      //console.log('isChecked', isChecked);
      self.somaMesAtual = !self.somaMesAtual;
      self.buscarDados();
    });

    $(document).on('click', '.copy-row-btn', async function () {
      const headers = ['Campanha Clínicas', 'Leads', 'PN', '%'];

      // Criar uma tabela temporária para screenshot
      const tempTable = document.createElement('table');
      tempTable.className = 'screenshot-table';

      // Adicionar cabeçalhos
      const headerRow = tempTable.insertRow();
      headers.forEach(header => {
        const th = document.createElement('th');
        th.textContent = header;
        headerRow.appendChild(th);
      });

      // Adicionar dados
      let dataRow = tempTable.insertRow();
      let td = dataRow.insertCell();
      td.textContent = $(this).data('branch');

      td = dataRow.insertCell()
      td.textContent = $(this).data('leads');

      td = dataRow.insertCell()
      td.textContent = $(this).data('pn');

      td = dataRow.insertCell()
      td.textContent = $(this).data('aproveitamento');

      // Criar um elemento temporário para renderizar a tabela
      const tempDiv = document.createElement('div');
      tempDiv.style.position = 'fixed';
      tempDiv.style.top = '0';
      tempDiv.style.left = '0';
      tempDiv.style.background = 'white';
      tempDiv.style.padding = '20px';
      tempDiv.appendChild(tempTable);
      document.body.appendChild(tempDiv);

      try {
        // Capturar screenshot
        const canvas = await html2canvas(tempDiv);

        // Converter para blob
        canvas.toBlob(function (blob) {
          // Criar um objeto URL temporário
          /*const url = URL.createObjectURL(blob);
          
          // Criar um elemento de imagem temporário
          const img = document.createElement('img');
          img.src = url;
          
          // Criar um elemento de link temporário
          const link = document.createElement('a');
          link.href = url;
          link.download = 'tabela.png'; // Nome do arquivo
          
          // Clicar no link automaticamente
          link.click();*/

          // Tentar copiar para a área de transferência
          canvas.toBlob(async function (blob) {
            try {
              await navigator.clipboard.write([
                new ClipboardItem({
                  'image/png': blob
                })
              ]);
              window.toast({ error: false, text: 'Imagem baixada e copiada para a área de transferência!' });
            } catch (err) {
              console.error('Erro ao copiar para clipboard:', err);
              window.toast({ error: false, text: 'Imagem baixada! Não foi possível copiar para a área de transferência - use o arquivo baixado.' });
            }
          });

          // Limpar o URL temporário
          // URL.revokeObjectURL(url);
        });
      } catch (err) {
        console.error('Erro ao gerar screenshot:', err);
        window.toast({ error: true, text: 'Erro ao gerar screenshot' });
      } finally {
        // Limpar elemento temporário
        document.body.removeChild(tempDiv);
      }
    });

    $(document).on('click', '#js-only-franchise', function () {
      self.onlyFranchise = $(this).is(':checked');
      self.buscarDados();
    });
  }
}
